<template>
    <div class="rematch">
        <b-button
            variant="info"
            size="lg"
            class="modal-button"
            @click="proposeRematch"
            v-if="!rematchProposed"
            v-html="__('results.propose_rematch')"
        >
        </b-button>

        <b-button
            variant="info"
            size="lg"
            class="modal-button"
            v-if="rematchProposed && !rematchWasDenied"
            @click="proposeRematch"
            v-html="__('results.proposed_rematch')"
        >
        </b-button>

        <b-button
            variant="error"
            size="lg"
            class="modal-button"
            v-if="rematchWasDenied"
            v-html="__('results.rematch_denied')"
        >
        </b-button>
        <b-button
            variant="danger"
            size="lg"
            class="float-right ml-2 modal-button"
            @click="backToMatchmaking"
            v-if="!rematchProposed || rematchWasDenied"
            v-html="__('results.back_to_matchmaking')"
        >
        </b-button>
        <b-modal id="modal-ask-for-rematch" title="Rematchanfrage" @hidden="denyRematch" size="lg">
            <template #modal-footer class="d-flex">
                <div class="ml-auto">
                    <b-button
                        variant="success"
                        size="lg"
                        @click="acceptRematch"
                        v-if="!rematchWasAccepted"
                        v-html="__('results.accept_rematch')"
                    >
                    </b-button>

                    <b-button
                        variant="success"
                        size="lg"
                        v-if="rematchWasAccepted"
                        v-html="__('results.rematch_accepted')"
                    >
                    </b-button>
                    <b-button
                        variant="danger"
                        size="lg"
                        class="float-right"
                        @click="denyRematch"
                        v-html="__('results.rematch_denied_back')"
                    >
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: ['game'],
        data() {
            return {
                rematchProposed: false,
                rematchWasDenied: false,
                rematchWasAccepted: false,
                rematchUserCount: 0,
            }
        },
        mounted() {
            this.$root.$on('GameManagerProposeRematch', (status, newgame_id, usercount) => {
                this.rematchUserCount = usercount;
                console.log("GameManagerProposeRematch", status);
                if (status == "propose" && !this.rematchProposed) {
                    console.log("show rematch ask");
                    this.$bvModal.show('modal-ask-for-rematch');
                } else if ((status == "accept" || status == "propose") && newgame_id != null) {
                    this.rematchAccepted(newgame_id);
                }
                else if (status == "deny") {
                    this.rematchDenied();
                }
            });
        },

        methods: {
             proposeRematch() {
                console.log("rematch?");
                this.rematchProposed = true;
                axios.post("/games/" + this.game.id + "/rematch", {status: 'propose'}).then((response) => {
                })
            },
            acceptRematch() {
                axios.post("/games/" + this.game.id + "/rematch", {status: 'accept', rematchUsers: this.rematchUserCount}).then((response) => {
                    this.rematchWasAccepted = true;
                })
            },
            denyRematch() {
                axios.post("/games/" + this.game.id + "/rematch", {status: 'deny'}).then((response) => {
                    axios.post("/gotourl", {url: "/dashboard/"});
                })
            },
            rematchAccepted(newgame_id) {
                if (newgame_id) {
                    axios.post("/games/join", {game: newgame_id});
                }
            },
            rematchDenied() {
                this.rematchWasDenied = true;
            },
            backToMatchmaking() {
                axios.post("/gotourl", {url: "/dashboard/"});
            }
        }
    }
</script>

<style scoped>
    .modal-button {
        font-size: 2vw;
        margin-top: 1vw;
    }

    .modal-footer {
        display: none !important;
    }
</style>
